import styled from 'styled-components';
import { compose, fontFamily, fontSize, fontWeight, margin, textAlign } from 'styled-system';
import { theme } from '../../essentials/theme';
import { get } from '../../utils/themeGet';
import { getSemanticValue } from '../../utils/cssVariables';
function determineTextColor(props) {
    const { primary, secondary, disabled } = props;
    if (disabled) {
        return getSemanticValue('foreground-disabled');
    }
    if (secondary) {
        return getSemanticValue('foreground-neutral-emphasized');
    }
    if (primary) {
        return getSemanticValue('foreground-primary');
    }
    return 'inherit';
}
const Text = styled.span.attrs({ theme }).withConfig({ displayName: "Text", componentId: "sc-15p8f5j" }) `
    color: ${determineTextColor};
    font-size: ${get('fontSizes.2')};
    font-family: ${get('fonts.normal')};
    line-height: 1.4;
    margin: 0;

    ${compose(margin, fontSize, fontWeight, fontFamily, textAlign)}
`;
export { Text };
